import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectIsLoadingLicense = (store: StoreSchema) => store.license.isLoading